import { CSSProperties, useEffect, useState } from 'react';

interface IDiscountBadgeProps {
    discount?: number,
    text?: string,
    theme?: string, // no theme = 'red'; other options: 'white'
    classes?: string,
}

/**
 * Discount badge.
 */
const DiscountBadge = (props: IDiscountBadgeProps) => {

    const [style, setStyle] = useState<CSSProperties|undefined>(undefined);
    const [contentClasses, setContentClasses] = useState('bg-red text-white');

    useEffect(() => {

        if(!props.theme) return;

        if(props.theme === 'white'){
            setStyle({
                '--discount-badge-bg-color': '#fff',
                '--discount-badge-circle-color': '#000'
            } as CSSProperties);

            setContentClasses('bg-white text-black');
        }

        if(props.theme === 'yellow'){
            setStyle({
                '--discount-badge-bg-color': '#EFFF00',
                '--discount-badge-circle-color': '#000',
            } as CSSProperties);

            setContentClasses('bg-yellow-400 text-black');
        }

        if(props.theme === 'black-bg-yellow-text-white-circle'){
            setStyle({
                '--discount-badge-bg-color': '#000',
                '--discount-badge-circle-color': '#fff',
            } as CSSProperties);

            setContentClasses('bg-black text-yellow-400');
        }

        if(props.theme === 'black-bg-white-text-yellow-circle'){
            setStyle({
                '--discount-badge-bg-color': '#000',
                '--discount-badge-circle-color': '#EFFF00',
            } as CSSProperties);

            setContentClasses('bg-black text-white');
        }

    }, [props.theme]);

    return (
        <div className={`discount-badge relative flex items-center overflow-hidden ${ props.classes }`} style={ style }>
            <div className="discount-badge__triangle relative" />
            <div className={`discount-badge__content text-xs font-bold text-center px-2 h-full flex items-center relative whitespace-nowrap ${ contentClasses }`}>
                { props.text && <span>{ props.text }</span>}
                { !props.text && <span>SAVE { props.discount }%</span> }
            </div>
        </div>
    );
};

export default DiscountBadge;